/**
 * DOMContentLoaded
 */

document.addEventListener(`DOMContentLoaded`, () => {
});


/**
 * load
 */
window.addEventListener('load', () => {

  let tl = new TimelineMax({
    repeat: -1,
    delay: 1
  });

  tl.staggerFromTo(`.js-visual__women img`, 1, {
      alpha: 0,
      transformOrigin: "50%",
      scale: 1.1,
    }, {
      alpha: 1,
      transformOrigin: "50%",
      scale: 1.0,
      ease: Power4.easeIn,
    }, 0.25)
    .to(`.js-visual__women img`, 1, {
      alpha: 0,
      delay: 3
    })
    .staggerFromTo(`.js-visual__men img`, 1, {
      alpha: 0,
      transformOrigin: "50%",
      scale: 1.1,
    }, {
      alpha: 1,
      transformOrigin: "50%",
      scale: 1.0,
      ease: Power4.easeIn,
    }, 0.25)
    .to(`.js-visual__men img`, 1, {
      alpha: 0,
      delay: 3
    })


  let fadeAndSlide = (element, dis, duration) => {
    return TweenMax.fromTo(element, duration, {
      x: dis,
      alpha: 0
    }, {
      x: 0,
      alpha: 1
    });
  }

  let speed = 0.5
  let xDis = deviceIsSp ? 50 : 100;
  let _fade = document.querySelectorAll(`.js-fadein`);
  for (let i = 0; i < _fade.length; i++) {
    let fadeSide = fadeAndSlide(_fade[i], xDis, speed);
    let fadeTitle = new ScrollMagic.Scene({
        triggerElement: _fade[i],
        triggerHook: 0.6, // 開始の上下
        reverse: true,
        offset: 0, //トリガーの要素の上下
      })
      .setTween(fadeSide)
      .addTo(controller);
  }
});